"use client";

import { HubspotProvider } from "next-hubspot";

export function HubspotProviderWrapper({ children }: { children: React.ReactNode }) {
  return <HubspotProvider>{children}</HubspotProvider>;
}
